import React from 'react'

const SocialMedia = ({leftOnMobile = false}) => {
  return (
    <div className="">
      <h3 className={`${leftOnMobile ? '' : 'text-center'} lg:text-left font-bold lg:text-lg font-accent mb-4 lg:mb-5 uppercase`}>
        Social Media
      </h3>
      <div className={`flex ${leftOnMobile ? '' : 'justify-center'} lg:justify-start`}>
        <div className="mr-2">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/logos/khub_fb.jpg" alt="Facebook"/>
          </a>
        </div>
        <div className="mr-2">
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/logos/khub_yt.jpg" alt="Youtube"/>
          </a>
        </div>
        <div className="lg:mr-2">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/logos/khub_ig.jpg" alt="Instagram"/>
          </a>
        </div>
      </div>
    </div>
  )
}

export { SocialMedia }